import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";

// @ts-ignore
import { CWBDropdown } from "cwb-react";
import {
  IDropdownObject,
  ddlYesNo,
  ddlHeightFeet,
  ddlHeightInch,
} from "../../../interfaces/IDropdownObject";
import {
  IAuditionInfoSheetDto,
  IUnion,
} from "../../../interfaces/IAuditionInfoSheetDto";

import MultiSelect from "react-multi-select-component";
import { IMultiSelectOption } from "../../../interfaces/IMultiSelectOption";
import { ISessionTemplateInfoSheet } from "../../../interfaces/ISessionTemplateInfoSheet";

const InformationSection = (props: {
  t: any;
  sessionTemplateInfoSheet: ISessionTemplateInfoSheet;
  auditionInfoSheet?: IAuditionInfoSheetDto;
  handleChange?: (e: any) => void;
  isReadOnly: boolean;
  onDropdownChange?: (name: string, o: IDropdownObject) => void;
  onMultiSelectChange?: (name: string, lst: IMultiSelectOption[]) => void;
  isTvFilm: boolean;
}) => {
  const {
    t,
    sessionTemplateInfoSheet,
    isReadOnly,
    auditionInfoSheet,
    handleChange,
    onDropdownChange,
    onMultiSelectChange,
    isTvFilm,
  } = props;

  let willBackup = {} as IDropdownObject;
  let willExtra = {} as IDropdownObject;
  // let passport = {} as IDropdownObject;
  // let driverslicense = {} as IDropdownObject;
  let heightFeet = {} as IDropdownObject;
  let heightInch = {} as IDropdownObject;

  let eye = {} as IDropdownObject;
  let ddlEyeList = [] as IDropdownObject[];
  let hair = {} as IDropdownObject;
  let ddlHairList = [] as IDropdownObject[];

  let unionSelectedOptions = [] as IMultiSelectOption[];

  let ddlUnionOptionList = [] as IMultiSelectOption[];

  if (auditionInfoSheet && auditionInfoSheet.actorProfileDetailLists) {
    willBackup = ddlYesNo.find((x) => x.value === auditionInfoSheet.willbackup);
    willExtra = ddlYesNo.find((x) => x.value === auditionInfoSheet.willextra);
    // passport = ddlYesNo.find((x) => x.value === auditionInfoSheet.passport);
    // driverslicense = ddlYesNo.find(
    //   (x) => x.value === auditionInfoSheet.driverslicense
    // );
    heightFeet = ddlHeightFeet.find(
      (x) => x.value === auditionInfoSheet.heightfeet
    );
    heightInch = ddlHeightInch.find((x) => {
      if (
        auditionInfoSheet.heightfeet === 0 &&
        auditionInfoSheet.heightinches === 0
      ) {
        return undefined;
      }
      return x.value === auditionInfoSheet.heightinches;
    });
    ddlHairList = auditionInfoSheet.actorProfileDetailLists.hairTypes.map(
      (x) => {
        return {
          id: x.id,
          label: x.hairType,
          value: x.id,
        };
      }
    );
    hair = ddlHairList.find((x) => x.id === auditionInfoSheet.hair);

    ddlEyeList = auditionInfoSheet.actorProfileDetailLists.eyeTypes.map((x) => {
      return {
        id: x.id,
        label: x.eyeType,
        value: x.id,
      };
    });
    eye = ddlEyeList.find((x) => x.id === auditionInfoSheet.eyes);

    unionSelectedOptions =
      auditionInfoSheet.munion &&
      auditionInfoSheet.munion.map((x: IUnion) => {
        return {
          label: x.description,
          value: x.code.toString(),
        } as IMultiSelectOption;
      });

    ddlUnionOptionList = auditionInfoSheet.actorProfileDetailLists.unions.map(
      (x: IUnion) => {
        return {
          label: x.description,
          value: x.code.toString(),
        } as IMultiSelectOption;
      }
    );
  }

  return (
    <section>
      <Title>{t("Please review the information below")}</Title>
      <form>
        <div className="form-group row">
          <label className="col-6 col-form-label">
            {t("Agency")} :{" "}
            {sessionTemplateInfoSheet && sessionTemplateInfoSheet.agencyName}
          </label>
          <label className="col-6 col-form-label">
            {t("Phone")} :{" "}
            {sessionTemplateInfoSheet && sessionTemplateInfoSheet.agencyPhone}
          </label>
        </div>
        {/*  */}
        <br />
        <div className="form-group row">
          <div className="col-3">
            <label>{t("Home No.")}</label>
            <input
              type="text"
              className="form-control"
              aria-describedby={t("Home No.")}
              value={
                auditionInfoSheet && auditionInfoSheet.homephone
                  ? auditionInfoSheet.homephone
                  : ""
              }
              onChange={handleChange}
              readOnly={isReadOnly}
              name="homephone"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Cell No.")}</label>
            <input
              type="text"
              className="form-control"
              aria-describedby={t("Cell No.")}
              value={
                auditionInfoSheet && auditionInfoSheet.cellphone
                  ? auditionInfoSheet.cellphone
                  : ""
              }
              readOnly={isReadOnly}
              onChange={handleChange}
              name="cellphone"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
        </div>
        {/*  */}
        <div className="form-group row">
          <div className="col-3">
            <div className="row">
              <div className="col-6">
                <label>{t("Height")}</label>
                {isReadOnly ? (
                  <input
                    type="text"
                    className="form-control"
                    readOnly={isReadOnly}
                  />
                ) : (
                  <>
                    <StyledSmallCWBDropdown
                      value={heightFeet}
                      isValueSelected={true}
                      items={ddlHeightFeet}
                      onChange={(o: any) => onDropdownChange("heightfeet", o)}
                    />
                  </>
                )}
                <small
                  className="form-text text-muted"
                  style={{ visibility: "hidden" }}
                >
                  Error
                </small>
              </div>
              <div className="col-6">
                <label>&nbsp;</label>
                {isReadOnly ? (
                  <input
                    type="text"
                    className="form-control"
                    readOnly={isReadOnly}
                  />
                ) : (
                  <>
                    <StyledSmallCWBDropdown
                      value={heightInch}
                      isValueSelected={true}
                      items={ddlHeightInch}
                      onChange={(o: any) => onDropdownChange("heightinches", o)}
                    />
                  </>
                )}
                <small
                  className="form-text text-muted"
                  style={{ visibility: "hidden" }}
                >
                  Error
                </small>
              </div>
            </div>
          </div>
          <div className="col-3">
            <label>{t("Weight (lbs)")}</label>
            <input
              type="text"
              className="form-control"
              aria-describedby={t("Weight (lbs)")}
              value={
                auditionInfoSheet && auditionInfoSheet.weight
                  ? auditionInfoSheet.weight
                  : ""
              }
              readOnly={isReadOnly}
              onChange={handleChange}
              name="weight"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Hair Color")}</label>
            {isReadOnly ? (
              <input
                type="text"
                className="form-control"
                readOnly={isReadOnly}
              />
            ) : (
              <StyledLargeCWBDropdown
                value={hair}
                isValueSelected={true}
                items={ddlHairList}
                onChange={(o: any) => onDropdownChange("hair", o)}
              />
            )}
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-2">
            <label>{t("Eye Color")}</label>
            {isReadOnly ? (
              <input
                type="text"
                className="form-control"
                readOnly={isReadOnly}
              />
            ) : (
              <StyledLargeCWBDropdown
                value={eye}
                isValueSelected={true}
                items={ddlEyeList}
                onChange={(o: any) => onDropdownChange("eyes", o)}
              />
            )}
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
        </div>
        {/*  */}
        <div className="form-group row">
          <div className="col-3">
            <label>{t("Skirt")}</label>
            <input
              type="text"
              className="form-control"
              value={(auditionInfoSheet && auditionInfoSheet.skirt) || ""}
              aria-describedby={t("skirt")}
              onChange={handleChange}
              readOnly={isReadOnly}
              name="Skirt"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Shirt")}</label>
            <input
              type="text"
              className="form-control"
              value={(auditionInfoSheet && auditionInfoSheet.shirt) || ""}
              aria-describedby={t("shirt")}
              readOnly={isReadOnly}
              onChange={handleChange}
              name="Shirt"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Dress")}</label>
            <input
              type="text"
              className="form-control"
              aria-describedby={t("dress")}
              value={(auditionInfoSheet && auditionInfoSheet.dress) || ""}
              readOnly={isReadOnly}
              onChange={handleChange}
              name="Dress"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Blouse")}</label>
            <input
              type="text"
              className="form-control"
              aria-describedby={t("Blouse")}
              value={(auditionInfoSheet && auditionInfoSheet.blouse) || ""}
              readOnly={isReadOnly}
              onChange={handleChange}
              name="Blouse"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
        </div>
        <div className="form-group row">
          <div className="col-3">
            <label>{t("Pants")}</label>
            <input
              type="text"
              className="form-control"
              value={(auditionInfoSheet && auditionInfoSheet.pants) || ""}
              aria-describedby={t("Pants")}
              onChange={handleChange}
              readOnly={isReadOnly}
              name="Pants"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Jacket")}</label>
            <input
              type="text"
              className="form-control"
              value={(auditionInfoSheet && auditionInfoSheet.jacket) || ""}
              aria-describedby={t("Jacket")}
              readOnly={isReadOnly}
              onChange={handleChange}
              name="Jacket"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Shoes")}</label>
            <input
              type="text"
              className="form-control"
              aria-describedby={t("Shoes")}
              value={(auditionInfoSheet && auditionInfoSheet.shoe) || ""}
              readOnly={isReadOnly}
              onChange={handleChange}
              name="shoe"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Union")}</label>
            {isReadOnly ? (
              <input
                type="text"
                className="form-control"
                readOnly={isReadOnly}
              />
            ) : (
              <>
                {ddlUnionOptionList && ddlUnionOptionList.length > 0 && (
                  <MultiSelect
                    options={ddlUnionOptionList}
                    value={unionSelectedOptions}
                    onChange={(o: any) => onMultiSelectChange("munion", o)}
                    labelledBy={"Select"}
                    disabled={isReadOnly}
                  />
                )}
              </>
            )}
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
        </div>

        {/*  */}
        {/*<div className="form-group row">
          
          <div className="col-3">
            <label>{t("Driver License")}</label>
            {isReadOnly ? (
              <input
                type="text"
                className="form-control"
                readOnly={isReadOnly}
              />
            ) : (
              <StyledLargeCWBDropdown
                value={driverslicense}
                isValueSelected={true}
                items={ddlYesNo}
                onChange={(o: any) => onDropdownChange("driverslicense", o)}
              />
            )}
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Passport")}</label>
            {isReadOnly ? (
              <input
                type="text"
                className="form-control"
                readOnly={isReadOnly}
              />
            ) : (
              <StyledLargeCWBDropdown
                value={passport}
                isValueSelected={true}
                items={ddlYesNo}
                onChange={(o: any) => onDropdownChange("passport", o)}
              />
            )}
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
          <div className="col-3">
            <label>{t("Citizenship")}</label>
            <input
              type="text"
              className="form-control"
              aria-describedby={t("Citizenship")}
              value={auditionInfoSheet && auditionInfoSheet.citizenship}
              readOnly={isReadOnly}
              onChange={handleChange}
              name="citizenship"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
        </div>*/}
        {/*  */}
        {!isTvFilm && (
          <div className="form-group row">
            <div className="col-3">
              <label>{t("Will Work as Extra")}</label>
              {isReadOnly ? (
                <input
                  type="text"
                  className="form-control"
                  readOnly={isReadOnly}
                />
              ) : (
                <StyledLargeCWBDropdown
                  value={willExtra}
                  isValueSelected={true}
                  items={ddlYesNo}
                  onChange={(o: any) => onDropdownChange("willextra", o)}
                />
              )}
              <small
                className="form-text text-muted"
                style={{ visibility: "hidden" }}
              >
                Error
              </small>
            </div>

            <div className="col-3">
              <label>{t("Will Work as Backup")}</label>
              {isReadOnly ? (
                <input
                  type="text"
                  className="form-control"
                  aria-describedby={t("Will Work as Backup")}
                  readOnly={isReadOnly}
                />
              ) : (
                <StyledLargeCWBDropdown
                  value={willBackup}
                  isValueSelected={true}
                  items={ddlYesNo}
                  onChange={(o: any) => onDropdownChange("willbackup", o)}
                />
              )}
              <small
                className="form-text text-muted"
                style={{ visibility: "hidden" }}
              >
                Error
              </small>
            </div>
          </div>
        )}
        {/*  */}
        <div className="form-group row">
          <div className="col-12">
            <label>{t("Other notes / Special Requests / Allergies")}</label>
            <textarea
              rows={4}
              className="form-control"
              aria-describedby={t("Other notes / Special Requests / Allergies")}
              value={
                (auditionInfoSheet && auditionInfoSheet.specialrequirements) ||
                ""
              }
              readOnly={isReadOnly}
              onChange={handleChange}
              name="specialrequirements"
            />
            <small
              className="form-text text-muted"
              style={{ visibility: "hidden" }}
            >
              Error
            </small>
          </div>
        </div>
      </form>
    </section>
  );
};

export default withI18n()(InformationSection);

const Title = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
  margin-top: 20px;
`;

const StyledSmallCWBDropdown = styled(CWBDropdown)`
  .cwb-dropdown__control {
    width: 104px;
  }
`;

const StyledLargeCWBDropdown = styled(CWBDropdown)`
  .cwb-dropdown__control {
    width: 238px;
  }
`;
